import './index.scss'

import Swiper, { Lazy, Pagination, Autoplay } from 'swiper/swiper-bundle.min.js';

Swiper.use([
    Lazy,
    Pagination,
    Autoplay
]);
import '../../assets/styles/jquery.fullpage.min.css'
import '../../assets/scripts/jquery.fullpage.min.js'

$(function () {

    $('#dowebok').fullpage({

        navigation: true,

        verticalCentered: false,

        // 重点：开启 CSS3 transform
        css3: true,

        scrollingSpeed: 700,

        slidesNavigation: false,

        anchors: [
            'page1',
            'page2',
            'page3',
            'page4',
            'page5',
            'page6',
            'page7'
        ],

        menu: '#menu',

        autoScrolling: true,

        fitToSection: true,

        afterLoad: function (anchorLink, index) {

        }

    });


    // 防抖
    var resizeTimer;

    $(window).on('resize', function () {

        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function () {

            autoScrolling();

        }, 150);

    });


    function autoScrolling() {

        var ww = $(window).width();

        if (ww < 1024) {

            $.fn.fullpage.setAutoScrolling(false);

            $.fn.fullpage.setFitToSection(false);

        } else {

            $.fn.fullpage.setAutoScrolling(true);

            $.fn.fullpage.setFitToSection(true);

        }

    }


    autoScrolling();

});
// 首页轮播
var banner = new Swiper('.section1 .swiper-container', {
	autoplay: {
        delay: 5000,
        disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
    navigation: {
        nextEl: ".section1 .next",
        prevEl: ".section1 .prev",
    },
}); 


$(".type-item").click(function(){
    $(this).addClass("active").siblings().removeClass("active");
    var type=$(this).data("type");
    $(".product-box").removeClass("active");
    $(".product-box[data-type='"+type+"']").addClass("active").find(".product-item").eq(0).trigger("click");
});


$(document).on("click",".product-item",function(){
    $(this).addClass("active").siblings().removeClass("active");

    $(".car-info h3").text($(this).data("title"));
    $(".car-info .size").text($(this).data("size"));
    $(".car-info p").html($(this).data("desc"));
    $(".car-img img").attr("src",$(this).data("img"));
    $(".more-btn").attr("href",$(this).data("more"));
    $(".product-btn").attr("data-title",$(this).data("title"));
});


$(".product-item.active").trigger("click");



$(".solution-pic img").eq(0).addClass("active");
$(".solution-item .item").eq(0).addClass("active");
$(".solution-nav li").eq(0).addClass("active");
$(".solution-nav li").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".solution-pic img").eq(index).addClass("active").siblings().removeClass("active");
    $(".solution-item .item").eq(index).addClass("active").siblings().removeClass("active");
})


$(".product-pop input").focus(function() {
    $(this).css("border-color","#e60012")
})
$(".product-pop input").blur(function() {
    $(this).css("border-color","#F7F7F7")
})
$(".product-pop textarea").focus(function() {
    $(this).css("border-color","#e60012")
})
$(".product-pop textarea").blur(function() {
    $(this).css("border-color","#F7F7F7")
})
$(".product-btn").click(function() {
    $(".product-pop").css('display','flex');
    let value = $(this).attr("data-title");
    $(".product-pop .form form ul li:nth-child(2) input").val(value);
})
$(".product-pop .model").click(function() {
    $(".product-pop").hide();
})
$(".product-pop .out").click(function() {
    $(".product-pop").hide();
})